/**
 * AuthSendCaptchaReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * AuthSendCaptchaReq
 */
export interface AuthSendCaptchaReq {
  /** 用户名 */
  username: string
  /** 认证场景 */
  scene: string
}

/**
 * AuthSendCaptchaReq Schema
 */
export const AuthSendCaptchaReqSchema: SchemaDefinition = {
  properties: {
    username: {
      description: '用户名',
      format: 'string',
      minLength: 2,
      type: 'string',
      label: '用户名',
    },
    scene: {
      description: '认证场景',
      format: 'cons.AuthScene',
      type: 'string',
      label: '认证场景',
    },
  },
  required: ['username', 'scene'],
  type: 'object',
}
